/* istanbul ignore file */
import React from 'react';
import { EnumDropdown, DefaultInputPropTypes } from 'framework/form';
import { ASSET_STATUS_OPTIONS } from 'domain/finance/assets/useAssetService';

const AssetStatusDropdown = (props: DefaultInputPropTypes<string>) => {
  return <EnumDropdown options={ASSET_STATUS_OPTIONS} {...props} />;
};

export default AssetStatusDropdown;
